import { useState, useEffect } from 'react';

/**
 * A value that follows another one, a little later.
 *
 * <p>For the search boxes: the loaded page is narrowed on every keystroke, and the
 * SERVER is asked once the typing settles. Sending on every keystroke would send
 * "s", "sm", "smi", "smit", "smith" — five requests for one word, the first four of
 * which nobody wants the answer to.
 *
 * @template T
 * @param {T} value
 * @param {number} ms how long the value must hold still
 * @returns {T} the value as of `ms` ago, or right now on the first render
 */
export default function useDebouncedValue(value, ms) {
    const [settled, setSettled] = useState(value);
    useEffect(() => {
        const timer = setTimeout(() => setSettled(value), ms);
        return () => clearTimeout(timer);
    }, [value, ms]);
    return settled;
}

/** How long a search box holds still before the server is asked. */
export const SEARCH_DEBOUNCE_MS = 400;
